// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { viewStyles } from "@cahaba/Overrides/Widgets/ProductDetails/ProductDetailsView";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

viewStyles.leftColumnGridItem = {
    css: css`
        overflow: hidden;
        direction: ltr;
        align-items: center;
        ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    margin-bottom: 15px;
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    margin-bottom: 15px;
                `,
                css`
                    flex-basis: 33.4%;
                    max-width: 33.4%;
                    padding-right: 15px;
                `,
                css`
                    flex-basis: 33.4%;
                    max-width: 33.4%;
                    padding-right: 15px;
                `,
                css`
                    flex-basis: 33.4%;
                    max-width: 33.4%;
                    padding-right: 15px;
                `,
            ])}
    `,
};

viewStyles.leftColumnGridItemWithBorder = {
    css: css`
        overflow: hidden;
        direction: ltr;
        ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    margin-bottom: 15px;
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                    margin-bottom: 15px;
                `,
                css`
                    flex-basis: 33.4%;
                    max-width: 33.4%;
                    padding-right: 15px;
                `,
                css`
                    flex-basis: 33.4%;
                    max-width: 33.4%;
                    padding-right: 15px;
                `,
                css`
                    flex-basis: 33.4%;
                    max-width: 33.4%;
                    padding-right: 15px;
                `,
            ])}
    `,
};

viewStyles.topWrapper = {
    css: css`
        flex: 0 0 100%;
        height: 100%;
    `,
};

viewStyles.middleWrapper = {
    css: css`
        margin-bottom: 15px;
    `,
};

viewStyles.rightColumnGridItem = {
    css: css`
        padding: 0px;
        flex-direction: column;
        align-items: center;
        ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    flex-basis: 66.6%;
                    max-width: 66.6%;
                    padding-left: 15px;
                `,
                css`
                    flex-basis: 66.6%;
                    max-width: 66.6%;
                    padding-left: 15px;
                `,
                css`
                    flex-basis: 66.6%;
                    max-width: 66.6%;
                    padding-left: 15px;
                `,
            ])}
    `,
};

viewStyles.rightColumnGridItemHidden = {
    css: css`
        width: 100%;
        background: #f3f1f1;
        padding: 15px;
        direction: ltr;
        height: 100%;
    `,
};

viewStyles.container = {
    css: css`
        direction: rtl;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        width: 100%;
        ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-wrap: wrap-reverse;
                    direction: ltr;
                `,
                css`
                    flex-wrap: wrap-reverse;
                    direction: ltr;
                `,
                css``,
                css``,
                css``,
            ])}
    `,
};

viewStyles.leftColumnInnerContainer = {
    css: css`
        border: 1px solid ${getColor("common.border")};
        height: 100%;
        padding: 15px;
    `,
};

viewStyles.fullColumnContainer = {
    css: css`
        flex: 0 0 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        direction: rtl;
        margin-bottom: 50px;
    `,
};

viewStyles.parentContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    `,
};
